import { useEffect, useState } from "react"
import { useSearchParams, useNavigate } from "react-router-dom"

import PaymentWidget from "widget/PaymentWidget"

import { convertProGradeAsName, ROOKIE, SEMI, TOUR } from "shared/constant/lookup/proGrade"
import { eventAmount } from "shared/constant/amountList"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

/**
 * @Desc 트라이아웃 실기 시험 결제 Page
*/
const TryoutRealExamPayment = () => {
    const navigate = useNavigate()

    const [searchParams] = useSearchParams()
    const proGradeType = parseInt(searchParams.get("proGradeType"))
    const examIdx = parseInt(searchParams.get("examIdx"))

    const [isError, setIsError] = useState(true)

    const [, setAlert] = useAlertModalAtom()


    // query 예외처리
    useEffect(() => {
        if (![ROOKIE, SEMI, TOUR].includes(proGradeType)) {
            setAlert("대상 프로 자격이 올바르지 않습니다.")
            navigate("/tryout-real")
        } else if (!examIdx || examIdx == "") {
            setAlert("실기 시험 idx가 올바르지 않습니다.")
            navigate("/tryout-real")
        } else {
            setIsError(false)
        }
    }, [])

    const props = {
        "amount": eventAmount,
        "orderName": `${convertProGradeAsName[proGradeType]} 프로 실기 시험 참가권`,
        "callbackUrl": `real/done?examIdx=${examIdx}`
    }

    return (
        !isError && <PaymentWidget {...props} />
    )
}

export default TryoutRealExamPayment